import React, { useState } from "react";

import { LineChart } from "@mui/x-charts/LineChart";

export default function (props) {
  const formatYAxisTick = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + "M";
    } else if (value >= 500000) {
      return "0.5M";
    } else if (value >= 0) {
      return "0M";
    } else {
      return value.toString();
    }
  };

  return (
    <LineChart
      xAxis={[
        {
          data: props.chartData.xAxisData.map(String),
          scaleType: "band",

          tickLabelStyle: {
            angle: -90,
            textAnchor: "end",
            fontSize: 12,
            fill: "#033666", // change x-axis label color
          },
          axisLine: {
            stroke: "#033666", // change x-axis line color
          },
        },
      ]}
      colors={["#003078"]}
      height={props.height}
      yAxis={[
        {
          scaleType: "linear",
          valueFormatter: formatYAxisTick,
          tickLabelStyle: {
            textAnchor: "end",
            fontSize: 12,
            fill: "#033666", // change x-axis label color
          },
          axisLine: {
            stroke: "#033666", // change x-axis line color
          },
        },
      ]}
      series={[
        {
          data: props.chartData.yAxisData,
        },
      ]}
      min={0}
      margin={{ top: 10, bottom: 100, left: 70, right: 10 }}
    />
  );
}
